module.exports = __webpack_public_path__ + "img/vertical_4_7_0.5f8f9a66.png";